import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=3f8f4aa7"
import script from "./MainTabs.vue?vue&type=script&lang=ts"
export * from "./MainTabs.vue?vue&type=script&lang=ts"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=3f8f4aa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports